import type { DataTableRenderCellParams as GridCellParams } from '@/components/custom/erp';
import { SearchSearchColumnDef } from '@/components/custom/erp';
import { formatDate, formatMoney } from '@/lib/formatUtils';

export const invoiceReportColumns = (
  handleDocumentEntryClick: (obj: MuaHangRecord) => void
): SearchSearchColumnDef[] => [
  {
    field: 'ma_unit',
    headerName: 'Đơn vị',
    width: 100
  },
  {
    field: 'ngay_ct3',
    headerName: 'Ngày c/từ',
    width: 110,
    renderCell: params => params.row.ngay_ct3 || params.row.ngay_ct
  },
  {
    field: 'so_ct3',
    headerName: 'Số c/từ',
    width: 140,
    renderCell: params => (
      <button onClick={() => handleDocumentEntryClick(params.row)} className='hover:text-blue-500 hover:underline'>
        {params.value}
      </button>
    )
  },
  {
    field: 'ngay_ct',
    headerName: 'Ngày nhập',
    width: 110
  },
  {
    field: 'so_ct',
    headerName: 'Số c/từ nhập',
    width: 140,
    renderCell: params => (
      <button onClick={() => handleDocumentEntryClick(params.row)} className='hover:text-blue-500 hover:underline'>
        {params.value}
      </button>
    )
  },
  {
    field: 'ngay_ct0',
    headerName: 'Ngày hóa đơn',
    width: 120
  },
  {
    field: 'so_ct0',
    headerName: 'Số hóa đơn',
    width: 150,
    renderCell: params => (
      <button onClick={() => handleDocumentEntryClick(params.row)} className='hover:text-blue-500 hover:underline'>
        {params.value}
      </button>
    )
  },
  {
    field: 'ma_kh',
    headerName: 'Mã NCC',
    width: 100
  },
  {
    field: 'ten_kh',
    headerName: 'Tên NCC',
    width: 200,
    cellClassName: (params: GridCellParams) => (params.row.stt === null ? 'font-bold' : '')
  },
  {
    field: 'dien_giai',
    headerName: 'Diễn giải',
    width: 200
  },
  {
    field: 'ma_vt',
    headerName: 'Mã vật tư',
    width: 120
  },
  {
    field: 'ten_vt',
    headerName: 'Tên vật tư',
    width: 200
  },
  {
    field: 'dvt',
    headerName: 'ĐVT',
    width: 80
  },
  {
    field: 'sl_nhap',
    headerName: 'Số lượng',
    width: 100,
    type: 'number',
    align: 'right',
    cellClassName: (params: GridCellParams) => (params.row.stt === null ? 'font-bold' : ''),
    renderCell: params => formatMoney(params.row.sl_nhap)
  },
  {
    field: 'gia',
    headerName: 'Giá',
    width: 120,
    type: 'number',
    align: 'right',
    cellClassName: (params: GridCellParams) => (params.row.stt === null ? 'font-bold' : ''),
    renderCell: params => formatMoney(params.row.gia)
  },
  {
    field: 'tien0',
    headerName: 'Tiền',
    width: 120,
    type: 'number',
    align: 'right',
    cellClassName: (params: GridCellParams) => (params.row.stt === null ? 'font-bold' : ''),
    renderCell: params => formatMoney(params.row.tien0)
  },
  {
    field: 'ck',
    headerName: 'Chiết khấu',
    width: 120,
    type: 'number',
    cellClassName: (params: GridCellParams) => (params.row.stt === null ? 'font-bold' : ''),
    renderCell: params => formatMoney(params.row.ck)
  },
  {
    field: 'tien_nhap',
    headerName: 'Tiền nhập',
    width: 120,
    type: 'number',
    align: 'right',
    renderCell: params => formatMoney(params.row.tien_nhap),
    cellClassName: (params: GridCellParams) => (params.row.stt === null ? 'font-bold' : '')
  },
  {
    field: 'thue',
    headerName: 'Thuế',
    width: 100,
    type: 'number',
    align: 'right',
    cellClassName: (params: GridCellParams) => (params.row.stt === null ? 'font-bold' : ''),
    renderCell: params => formatMoney(params.row.thue)
  },
  {
    field: 'ma_tc_thue',
    headerName: 'Mã tính chất',
    width: 120
  },
  {
    field: 'thue_suat',
    headerName: 'Thuế suất',
    width: 150,
    type: 'number',
    align: 'right'
  },
  {
    field: 'cp',
    headerName: 'Chi phí',
    width: 120,
    type: 'number',
    align: 'right',
    cellClassName: (params: GridCellParams) => (params.row.stt === null ? 'font-bold' : ''),
    renderCell: params => formatMoney(params.row.cp)
  },
  {
    field: 'tong_tt',
    headerName: 'Tổng thanh toán',
    width: 140,
    type: 'number',
    align: 'right',
    cellClassName: (params: GridCellParams) => (params.row.stt === null ? 'font-bold' : ''),
    renderCell: params => formatMoney(params.row.tong_tt)
  },
  {
    field: 'ma_kho',
    headerName: 'Mã kho',
    width: 100
  },
  {
    field: 'tk_vt',
    headerName: 'TK vật tư',
    width: 100
  },
  {
    field: 'tk_du',
    headerName: 'TK công nợ',
    width: 120
  },
  {
    field: 'ma_bp',
    headerName: 'Bộ phận',
    width: 120
  },
  {
    field: 'ma_vv',
    headerName: 'Vụ việc',
    width: 120
  },
  {
    field: 'ma_hd',
    headerName: 'Hợp đồng',
    width: 120
  },
  {
    field: 'ma_dtt',
    headerName: 'Đợt thanh toán',
    width: 130
  },
  {
    field: 'ma_ku',
    headerName: 'Khế ước',
    width: 120
  },
  {
    field: 'ma_phi',
    headerName: 'Phí',
    width: 100
  },
  {
    field: 'ma_sp',
    headerName: 'Sản phẩm',
    width: 120
  },
  {
    field: 'ma_lsx',
    headerName: 'Lệnh sản xuất',
    width: 130
  },
  {
    field: 'ma_cp0',
    headerName: 'C/p không h/lệ',
    width: 130
  },
  {
    field: 'ma_ct',
    headerName: 'Mã c/từ',
    width: 120
  }
];
